import { IExecutionOptions } from '@kurtosys/types/query/IExecutionOptions.js';
import { IQueryOptionsNone } from '@kurtosys/types/query/options/IQueryOptionsNone.js';

import { applySubQueryPlaceholders } from '../queryUtils/applySubQueryPlaceholders.js';

import { BaseQuery } from './base/BaseQuery.js';

export class ValueQuery extends BaseQuery<IQueryOptionsNone> {
	getOptions(): IQueryOptionsNone {
		const { value, subQueries, allSubQueryValuesRequired, options = {} } = this.queryOptions;
		return {
			value,
			subQueries,
			allSubQueryValuesRequired,
			...(options.none || {}),
		};
	}
	getRawValue<T = any>(executionOptions: IExecutionOptions): T {
		const { value, subQueries, allSubQueryValuesRequired } = this.options;
		return applySubQueryPlaceholders({
			dependencies: this.dependencies,
			executionOptions,
			subQueries,
			allSubQueryValuesRequired,
			template: value,
			translationHelper: this.translationHelper,
		}) as any as T;
	}
}
